<div class="block w-full text-center font-normal text-base font-theme-source text-theme-white p-3 text-white rounded-2xl border-3 border-white">
  <div class="h-[17px] w-full flex flex-wrap gap-1 align-middle justify-center">
    <p class="text-theme-red"><i class="fa-solid fa-heart"></i></p>
    <p class="text-theme-red"><i class="fa-solid fa-heart"></i></p>
    <p class="text-theme-red"><i class="fa-solid fa-heart"></i></p>
    <p class="text-theme-red"><i class="fa-solid fa-heart"></i></p>
    <p class="text-theme-red"><i class="fa-solid fa-heart"></i></p>
  </div>
  <div class="w-full mt-4">
    <ng-content></ng-content>
  </div>
</div>
